import React from 'react';

function Contact() {
  return (
    <div className="max-w-lg mx-auto mt-8">
      <h1 className="text-2xl mb-4">Contact</h1>
      <p>If you have any questions, please reach out to us at contact@example.com.</p>
    </div>
  );
}

export default Contact;



